// extracted by mini-css-extract-plugin
export default {"box":"box_box__LV3bp","boxup":"box_boxup__xNyr6","boxdown":"box_boxdown__Y8jhk","boximg":"box_boximg__SFSB+"};